import React from 'react';
import PropTypes from 'prop-types';

function AttachedNewEntity({
                             localId,
                             name,
                             removeCallback,
                             subheading,
                             type,
                           }) {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      removeCallback(localId);
    }
  };

  return (
    <div className="attached-entity-card bg-white mt-2 me-2 d-inline-flex flex-row align-items-center">
      <div className="">
        <strong>{name}</strong>
        <div className="small text-secondary">{subheading}</div>
        <div className="mt-1 badge rounded-pill text-bg-secondary">New {type}</div>
      </div>
      <div
        className="attached-entity-remove btn p-2 rounded-2 text-body d-flex align-items-center justify-content-center"
        onClick={() => removeCallback(localId)}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex="0"
      >
        <i className="fa-solid fa-xmark" />
      </div>
    </div>
  );
}

AttachedNewEntity.propTypes = {
  localId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  removeCallback: PropTypes.func.isRequired,
  subheading: PropTypes.string,
  type: PropTypes.string.isRequired,
};

AttachedNewEntity.defaultProps = {
  subheading: undefined,
};

export default AttachedNewEntity;
